// src/index.tsx
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// Limpia SW y caches antiguos
(function cleanupSW(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (typeof process !== "undefined" && process.env.NODE_ENV !== "production")
    return;

  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .finally(() => {
      if ("caches" in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
    })
    .catch(() => {
      /* no-op */
    });
})();

const container = document.getElementById("root");
if (!container) throw new Error("Root element '#root' not found");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
